import * as React from "react";
import {Button, OverlayTrigger, Tooltip} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import {LcdIcon} from "../common/ui/icon/LcdIcon";
import {Service, ServiceTypeDetails} from "./model";
import axios from "axios";
import {oidcProviderInfo} from "../oidc/startOidcProvider";
import {WithApi, WithApiProperties} from "../common/util/WithApi";

interface ServiceGetCapabilitiesButtonStateProps {
  service: Service;
  serviceTypeDetails: ServiceTypeDetails;
}

interface ServiceGetCapabilitiesButtonOtherProps {
  bsSize?: string;
  disabled?: boolean;
}

type ServiceGetCapabilitiesButtonProps =
    ServiceGetCapabilitiesButtonStateProps
    & ServiceGetCapabilitiesButtonOtherProps
    & WithApiProperties;

const shouldShowCapabilities = (serviceTypeDetails: ServiceTypeDetails) => {
  return serviceTypeDetails && serviceTypeDetails.hasCapabilities;
};

export class ServiceGetCapabilitiesButtonComponent extends React.Component<ServiceGetCapabilitiesButtonProps, {}> {

  render() {
    const isOidcEnabled = oidcProviderInfo?.enabled;
    const endPointUrl = this.props.api.getAbsoluteUrl(this.props.service.endpointPath);
    let getCapabilitiesUrl = `${endPointUrl}?service=${this.props.service.type.toUpperCase()}&request=GetCapabilities`;

    if (shouldShowCapabilities(this.props.serviceTypeDetails)) {
      if (isOidcEnabled) {
        axios
            .get(getCapabilitiesUrl)
            .then((r) => {
              const blob = new Blob([r.data], {type: 'text/xml'});
              getCapabilitiesUrl = URL.createObjectURL(blob);
            });
      }
      let svcBtn = <Button onClick={(_event) => window.open(getCapabilitiesUrl, "_blank", "noreferrer")}>
        <LcdIcon icon="search"/>
        <FormattedMessage id="studio.services.service-get-capabilities" defaultMessage="Get Capabilities"/>
      </Button>;

      if (isOidcEnabled) {
        svcBtn = <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip_getcapabilities_button">
          <FormattedMessage
              id="studio.services.service-get-capabilities-help-oidc"
              defaultMessage="OpenID is enabled. GetCapabilities document will be opened in a new tab as a BLOB URL to allow for authentication."
          />
        </Tooltip>}>
          {svcBtn}
        </OverlayTrigger>;
        URL.revokeObjectURL(getCapabilitiesUrl); //Releases the resources
      }
      return svcBtn;
    }

    return null;
  }

}

export const ServiceGetCapabilitiesButton = WithApi(ServiceGetCapabilitiesButtonComponent);
